import { RG_TYPE, getRgObjectsOfType, GetAllBones, roundDecimals } from "@project-rouge/rg-core";
const includeTypes = [RG_TYPE.Apartment, RG_TYPE.TechnicalSpace];
function getRgHash(obj) {
  const zones = getRgObjectsOfType(obj, RG_TYPE.Zone);
  const buildings = getRgObjectsOfType(zones, RG_TYPE.Building);
  const childrenMap = /* @__PURE__ */ new Map();
  for (const building of buildings) {
    let facade;
    const boneFloors = new Map(GetAllBones(building.data.anatomy).map((b) => [b.id, b.floors]));
    const topLevels = building.data.levels.filter((lvl) => lvl.bones.every((b) => boneFloors.get(b) === lvl.levelIndex + 1)).map((lvl) => lvl.uuid);
    for (const child of building.children) {
      if (child.type === RG_TYPE.EmptySpace) {
        addChild(child, childrenMap);
        continue;
      }
      if (!facade && child.type === RG_TYPE.Facade) {
        facade = child;
        addChild(child, childrenMap);
        continue;
      }
      if (!includeTypes.includes(child.type))
        continue;
      if (child.type === RG_TYPE.TechnicalSpace) {
        addChild(child, childrenMap);
        continue;
      }
      if (!topLevels.includes(child.data.levelId))
        continue;
      addChild(child, childrenMap);
    }
  }
  const childrenSorted = [...childrenMap.entries()].sort((a, b) => {
    if (a[0] < b[0])
      return -1;
    if (a[0] > b[0])
      return 1;
    return 0;
  });
  childrenSorted.forEach((group) => {
    group[1].sort((a, b) => a - b);
  });
  const childrenHash = childrenSorted.map((group) => `${group[0]}_${group[1].join("_")}`).join("\n");
  const polysHash = zones.map((z) => z.data.polygons.flat().flat().flatMap((v) => roundDecimals(v))).join("_");
  const realPolysHash = zones.map((z) => z.data.realPoly.flat().flatMap((v) => roundDecimals(v))).join("_");
  return [
    childrenHash,
    polysHash,
    realPolysHash
  ].join("\n");
}
function addChild(child, store) {
  const name = getChildName(child);
  if (!store.has(name))
    store.set(name, []);
  store.get(name).push(getChildPos(child));
}
function getChildName(child) {
  if (child.type === RG_TYPE.Facade)
    return child.modulousId || child.name;
  if (child.type === RG_TYPE.Apartment)
    return child.name.replace("Scarlet ", "");
  return child.name;
}
function getChildPos(child) {
  if (child.type === RG_TYPE.Facade)
    return 0;
  return roundDecimals(child.pos[0] * 1e9 + child.pos[1] * 1e6 + child.pos[2] * 1e3 + child.size[1]);
}
export {
  getRgHash
};
//# sourceMappingURL=index84.js.map
